// src/utils/error.ts
var MediaErrorType = /* @__PURE__ */ ((MediaErrorType2) => {
  MediaErrorType2[MediaErrorType2["MEDIA_ERR_ABORTED"] = 1] = "MEDIA_ERR_ABORTED";
  MediaErrorType2[MediaErrorType2["MEDIA_ERR_NETWORK"] = 2] = "MEDIA_ERR_NETWORK";
  MediaErrorType2[MediaErrorType2["MEDIA_ERR_DECODE"] = 3] = "MEDIA_ERR_DECODE";
  MediaErrorType2[MediaErrorType2["MEDIA_ERR_SRC_NOT_SUPPORTED"] = 4] = "MEDIA_ERR_SRC_NOT_SUPPORTED";
  return MediaErrorType2;
})(MediaErrorType || {});
function isError(e) {
  return typeof e === "object" && e !== null && "name" in e && "message" in e;
}
function isAbortError(e) {
  return toError(e).name === "AbortError";
}
function isMediaError(e) {
  return typeof e === "object" && e !== null && e.name === void 0 && e.MEDIA_ERR_ABORTED === 1 && typeof e.code === "number";
}
function toError(e, context) {
  if (isError(e)) {
    return e;
  }
  return context ? new Error(`${context}: ${e}`) : new Error(`${e}`);
}
function isMediaErrorFatal(error) {
  return error.code !== error.MEDIA_ERR_ABORTED;
}
function getMediaErrorCodeName(error) {
  return MediaErrorType[error.code];
}
function stringifyError(e) {
  if (typeof e !== "object" || e === null) {
    return `${e}`;
  }
  const plainObject = toPlainObject(e);
  return JSON.stringify(plainObject);
}
function toPlainObject(obj) {
  const result = {};
  Object.getOwnPropertyNames(obj).concat(["name", "message", "stack", "msExtendedCode"]).filter((prop) => !/^(\d+|[A-Z_]+)$/.exec(prop)).filter((prop) => obj[prop] !== void 0).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null) {
      result[prop] = toPlainObject(obj[prop]);
    } else {
      result[prop] = obj[prop];
    }
  });
  if (isMediaError(obj)) {
    result.name = "MediaError";
  }
  return result;
}

export {
  isError,
  isAbortError,
  toError,
  isMediaErrorFatal,
  getMediaErrorCodeName,
  stringifyError
};
